<template>
  <transition name="fade">
    <div
      class="login"
      v-show="loginVisible"
      ref="login"
    >
      <div
        class="login-close"
        @click="closeLogin"
        v-if="closeLoginVisible"
      >
        <img src="@/assets/images/plus-symbol.svg">
        Close
      </div>
      <div class="container">
        <form
          @submit="onSubmit"
          class="loginForm"
        >
          <h3 class="textNav">{{$t('login.login')}}</h3>
          <label
            for="email"
            class="formGroup"
          >
            <input
              id="email"
              v-model="form.email"
              type="email"
              :placeholder="$t('login.email')"
            >
          </label>
          <label
            for="emailCode"
            class="formGroup"
          >
            <input
              id="emailCode"
              v-model="form.code"
              type="tel"
              :placeholder="$t('login.password')"
            >
            <button
              type="button"
              class="emailCodeBtn"
              @click="sendEmail"
            >{{sendEmailText}}</button>
          </label>
          <div class="text-right">
            <!-- <a
              href=""
              class="againEmail"
            >{{$t('login.againEmailCode')}}</a> -->
            <button
              class="submitBtn"
              type="submit"
            >
              <b-icon icon="chevron-compact-right"></b-icon>
              {{$t('login.nowLogin')}}
            </button>
          </div>
          <!-- <p class="cut">{{$t('login.or')}}</p>
          <button class="submit-btn-danger">
            <b-icon icon="chevron-compact-right"></b-icon>
            {{$t('login.nowLogin')}}
          </button> -->
        </form>

      </div>
    </div>
  </transition>
</template>

<script>
import { getCode, login } from '@/api/coupon'
export default {
  props: {
    loginVisible: {
      type: [Boolean, String],
      default: false,
    }
  },
  data () {
    return {
      form: {
        email: '',
        code: ''
      },
      clientHeight: document.documentElement.clientHeight,
      countdown: 30,
      sendEmailText: this.$t('login.emailCode'),
      timeInterval: null,
      winHeight: '',
      closeLoginVisible: true,
      // 登录之后跳转的页面
      loginJumpName: 'member',
      // 登陆后的回调
      loginCallBack: null
    }
  },
  mounted () {
    if (navigator.userAgent.includes('Android')) {
      // 安卓手机
      this.winHeight = window.innerHeight;
      window.addEventListener('resize', this.keyboardReize)
    }
    this.$bus.$on('showLogin', (closeLoginVisible = true, returnName = null, loginCallBack) => {
      this.$emit('update:loginVisible', true)
      this.closeLoginVisible = closeLoginVisible
      this.loginJumpName = returnName
      this.loginCallBack = loginCallBack
    })
  },
  destroyed () {
    if (navigator.userAgent.includes('Android')) {
      // 安卓手机
      this.winHeight = window.innerHeight;
      window.removeEventListener('resize', this.keyboardReize)
    }
  },
  methods: {
    async onSubmit (event) {
      event.preventDefault()
      if (this.form.email.trim().length === 0 || this.form.code.trim().length === 0) {
        return this.$message.info(this.$t('login.verification'))
      }
      const res = await login(this.form).catch(err => {
        let errText = ''
        if (err.response.data.meta.error === 'MEMBER_VERIFICATION_CODE_WRONG') {
          // 说明是验证码错误
          if (localStorage.getItem('lang') === 'zh') {
            errText = '驗證碼錯誤'
          } else {
            errText = 'VERIFICATION_CODE_WRONG'
          }
          this.$message.error(errText)
        }
      })
      if (res) {
        localStorage.setItem('token', res.data.token)
        this.closeLogin()
        if (this.loginCallBack) {
          this.loginCallBack()
        }
        this.$nextTick(() => {
          if (this.loginJumpName) {
            // 存在的情况下
            this.$router.push({ name: this.loginJumpName })
          } else {
            this.$bus.$emit('getInfo')
          }
        })

      }
      // window.location.reload()
    },
    closeLogin () {
      this.form = {}
      this.$emit('update:loginVisible', false)
    },
    sendEmail (event) {
      if (/[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/.test(this.form.email)) {
        event.target.setAttribute('disabled', true)
        this.sendEmailText = this.countdown
        this.timeInterval = setInterval(() => {
          if (this.countdown !== 0) {
            this.countdown--
            this.sendEmailText = this.countdown
          } else {
            this.countdown = 30
            this.sendEmailText = this.$t('login.emailCode')
            event.target.removeAttribute('disabled')
            clearInterval(this.timeInterval)
          }
        }, 1000)
        getCode({ 'email': this.form.email })
      } else {
        this.$message.error(this.$t('login.emailVerification'))
      }
    },
    keyboardReize () {
      const innerHeight = window.innerHeight;
      if (this.winHeight > innerHeight) {
        // 键盘弹出
        document.querySelector('.login').style.top = `-${innerHeight / 2}px`
        document.querySelector('.login').style.height = `calc(100% + ${innerHeight / 2}px)`
      } else {
        // 键盘收起
        document.querySelector('.login').style.top = '0'
        document.querySelector('.login').style.height = '100%'
      }
    }
  },
  watch: {
    loginVisible (newVal, oldVal) {
      if (newVal) {
        // 让 body 高度 = 100%,超出隐藏
        document.body.classList.add('hidden-module-login')
      } else {
        // 取消上面操作
        document.body.classList.remove('hidden-module-login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #0f96bb;
input {
  outline: none;
}
button {
  border: none;
  outline: none;
  background-color: transparent;
}
.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 122, 170, 0.7);
  z-index: 1002;
}
.login-close {
  position: absolute;
  top: 20px;
  right: 10px;
  display: flex;
  align-items: flex-end;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
  > img {
    display: block;
    width: 40px;
  }
}

.container {
  position: absolute;
  width: 500px;
  height: 500px;
  top: 300px;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 50%;
  background-color: #fff;
  z-index: 1000;
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 30%;
    height: 400px;
    top: -300px;
    border-radius: 50%;
    background-color: #fff;
    z-index: 100;
  }
  &::before {
    left: 0%;
    transform: rotate(-30deg);
  }
  &::after {
    right: 0%;
    transform: rotate(30deg);
  }
}
.container {
  .loginForm {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 75%;
    display: flex;
    flex-direction: column;
    .textNav {
      color: $text-color;
    }
    .formGroup {
      padding: 10px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #000;
      input {
        width: 100%;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .emailCodeBtn {
        position: relative;
        padding: 5px 0;
        min-width: 90px;
        font-size: 16px;
        color: $text-color;
        border: 1px solid $text-color;
        border-radius: 5px;
        transition: all 0.2s ease;
        white-space: nowrap;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: #fff;
          z-index: -2;
        }
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 100%;
          background-color: $text-color;
          transition: all 0.2s ease;
          z-index: -1;
        }
        &:hover {
          &::after {
            width: 100%;
          }
          color: #fff;
        }
        &:disabled {
          cursor: not-allowed;
          color: #fff;
          background-color: #c6c6c6;
          border: none;
          &::before,
          &::after {
            width: 0;
            height: 0;
          }
        }
      }
    }
    .againEmail {
      align-self: flex-start;
      color: $text-color;
      font-size: 16px;
      // border-bottom: 1px solid #000;
      text-decoration: underline;
    }
    .submitBtn {
      position: relative;
      margin-left: 5px;
      font-size: 18px;
      padding: 12px 30px;
      color: $text-color;
      transition: all 0.2s ease;
      border: 1px solid $text-color;
      white-space: nowrap;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        z-index: -2;
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 100%;
        background-color: $text-color;
        transition: all 0.2s ease;
        z-index: -1;
      }
      &:hover {
        &::after {
          width: 100%;
        }
        color: #fff;
      }
    }
    .cut {
      position: relative;
      margin: 30px auto;
      font-size: 20px;
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 1px;
        background-color: #949494;
      }
      &::before {
        left: -30px;
        top: 50%;
      }
      &::after {
        right: -30px;
        top: 50%;
      }
    }
    .submit-btn-danger {
      margin: 0 auto;
      padding: 12px 30px;
      color: #fff;
      font-size: 18px;
      background-color: #d4517e;
      &:hover {
        background-color: #d3215f;
      }
    }
  }
}

@media screen and(max-width:768px) {
  .container {
    width: 75vw;
    height: 75vw;
    top: 55vw;
    &::before,
    &::after {
      width: 30%;
      height: 55vw;
      top: -42vw;
    }
  }
  .container {
    .loginForm {
      width: 80%;
      .formGroup {
        padding: 5px 0;
        input {
          font-size: 12px;
        }
        .emailCodeBtn {
          font-size: 12px;
        }
      }
      .againEmail {
        font-size: 10px;
      }
      .submitBtn {
        font-size: 12px;
        padding: 5px 10px;
      }
      .cut {
        margin: 5px auto;
        font-size: 16px;
      }
      .submit-btn-danger {
        font-size: 12px;
        padding: 5px 10px;
      }
    }
  }
}

/* vue动画 */
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-out 0.4s;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>